import React from "react";
import { Laptop, Smartphone, MonitorPlay, Cloud, Check, Server } from "lucide-react";
import { useM } from "../useM";
import { Eyebrow, Reveal } from "../ui";

const Node = ({ icon: Icon, className = "" }) => (
  <div className={`absolute flex h-14 w-14 items-center justify-center rounded-xl border border-white/15 bg-mk-navy ${className}`}>
    <Icon size={22} className="text-white/80" />
  </div>
);

const LanDiagram = () => (
  <div className="relative mx-auto aspect-square w-full max-w-md" aria-hidden="true">
    <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 400" fill="none">
      <circle cx="200" cy="230" r="150" stroke="rgba(255,255,255,0.06)" />
      <circle cx="200" cy="230" r="95" stroke="rgba(255,255,255,0.06)" />
      {[[80, 140], [320, 140], [80, 330], [320, 330]].map(([x, y]) => (
        <line key={`${x}${y}`} x1="200" y1="230" x2={x} y2={y} stroke="hsl(221 100% 60%)" strokeOpacity="0.7" strokeDasharray="4 6" />
      ))}
      <line x1="200" y1="230" x2="200" y2="48" stroke="hsl(221 100% 60%)" strokeOpacity="0.4" strokeDasharray="2 8" />
    </svg>
    <div className="absolute left-1/2 top-[57.5%] flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl border border-mk-yellow/60 bg-mk-yellow/10 shadow-[0_0_60px_rgba(255,213,0,0.3)]">
      <Server size={30} className="text-mk-yellow" />
    </div>
    <div className="absolute left-1/2 top-[12%] flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-dashed border-white/20">
      <Cloud size={22} className="text-white/50" />
    </div>
    <Node icon={Laptop} className="left-[20%] top-[35%] -translate-x-1/2 -translate-y-1/2" />
    <Node icon={MonitorPlay} className="left-[80%] top-[35%] -translate-x-1/2 -translate-y-1/2" />
    <Node icon={Smartphone} className="left-[20%] top-[82.5%] -translate-x-1/2 -translate-y-1/2" />
    <Node icon={Smartphone} className="left-[80%] top-[82.5%] -translate-x-1/2 -translate-y-1/2" />
  </div>
);

export const OfflineSpotlight = () => {
  const m = useM();
  return (
    <section className="mx-auto grid max-w-7xl items-center gap-16 px-6 py-28 lg:grid-cols-2 lg:px-10 lg:py-40" data-testid="offline-section">
      <Reveal>
        <Eyebrow>{m("offline.eyebrow")}</Eyebrow>
        <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[0.95] text-white sm:text-5xl lg:text-6xl">{m("offline.title")}</h2>
        <p className="mt-6 max-w-xl text-sm leading-relaxed text-mk-muted md:text-lg">{m("offline.sub")}</p>
        <ul className="mt-10 space-y-4">
          {["offline.p1", "offline.p2", "offline.p3"].map((k) => (
            <li key={k} className="flex items-start gap-3 text-sm text-white/85 md:text-base">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-mk-yellow/15"><Check size={12} className="text-mk-yellow" /></span>
              {m(k)}
            </li>
          ))}
        </ul>
      </Reveal>
      <Reveal delay={0.15}><LanDiagram /></Reveal>
    </section>
  );
};
